import React from 'react';

const responseErrorExtractor = res => {
  return res ? res.msg || res.message || '' : '';
};

export default responseErrorExtractor;
